document.addEventListener("DOMContentLoaded", function() {
    const faqButtons = document.querySelectorAll(".mf_faq-question");
    
    if(faqButtons){
        faqButtons.forEach((button, index) => {
          const answer = button.nextElementSibling;
          const iconImg = button.querySelector(".mf_faq-icon img");
      
          if (answer && answer.classList.contains("mf_faq-answer")) {
            answer.style.overflow = "hidden";
      
            // Open first by default
            if (index === 0) {
              button.setAttribute("aria-expanded", "true");
              answer.style.maxHeight = answer.scrollHeight + "px";
              if (iconImg) {
                iconImg.src = button.dataset.minus;
                iconImg.alt = "minus";
              }
            } else {
              button.setAttribute("aria-expanded", "false");
              answer.style.maxHeight = "0";
            }
      
            button.addEventListener("click", () => {
              const expanded = button.getAttribute("aria-expanded") === "true";
      
              // Close all others
              faqButtons.forEach(btn => {
                btn.setAttribute("aria-expanded", "false");
                const ans = btn.nextElementSibling;
                const ic = btn.querySelector(".mf_faq-icon img");
                if (ans && ans.classList.contains("mf_faq-answer")) {
                  ans.style.maxHeight = "0";
                }
                if (ic) {
                  ic.src = btn.dataset.pluse;
                  ic.alt = "plus";
                }
              });
      
              // Open clicked one if it was closed
              if (!expanded) {
                button.setAttribute("aria-expanded", "true");
                answer.style.maxHeight = answer.scrollHeight + "px";
                if (iconImg) {
                  iconImg.src = button.dataset.minus;
                  iconImg.alt = "minus";
                }
              }
            });
          }
        });
    }
  });